import { render, staticRenderFns } from "./CompButtonPrimaryRed.vue?vue&type=template&id=2191cf2a&scoped=true"
import script from "./CompButtonPrimaryRed.vue?vue&type=script&setup=true&lang=js"
export * from "./CompButtonPrimaryRed.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompButtonPrimaryRed.vue?vue&type=style&index=0&id=2191cf2a&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2191cf2a",
  null
  
)

export default component.exports